import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wre-release-note',
    templateUrl: './release-note.component.html',
    styleUrls: ['./release-note.component.scss'],
    standalone: false
})
export class ReleaseNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
